// src/pages/Home.jsx
import BannerSlider from "../components/banner/BannerSlider";
import GameGrid from "../components/games/GameGrid";
import EventGrid from "../components/events/EventGrid";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

export default function Home() {
  return (
    <div className="container mx-auto p-6 mt-12 mb-14 space-y-14">

      {/* ─ 배너 섹션 ─ */}
      <div className="space-y-8">
        <div className="w-full flex justify-center relative">
          <BannerSlider />
        </div>
      </div>


      {/* ─ 인기 게임 ─ */}
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold">🪄 인기 게임</h2>
          <div className="flex gap-4 pr-6">
            <Link to="/games">
              <button className="flex items-center space-x-1 text-white hover:text-orange-500">
                <span>더보기</span>
                <FaChevronRight className="text-sm" />
              </button>
            </Link>
          </div>
        </div>
        <GameGrid
          collectionName="games"
          filterPopular={true}
          limit={4}
        />
      </div>
      
      {/* ─ 게임잼 ─ */}
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold">🎉 MYME 게임잼</h2>
          <div className="flex gap-4 pr-6">
            <Link 
              to="/games" 
              state={{ filterCategory: "gameJam", filterValue: "게임잼" }} 
            >
              <button className="flex items-center space-x-1 text-white hover:text-orange-500">
                <span>더보기</span>
                <FaChevronRight className="text-sm" />
              </button>
            </Link>
          </div>
        </div>
        <GameGrid
          collectionName="games"
          filterGamejam={true}
          limit={4}
        />
      </div>

      {/* ─ 게시판 ─ */}
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold">📢 MYME 소식</h2>
          <div className="flex gap-4 pr-6">
            <Link 
              to="/events" 
            >
              <button className="flex items-center space-x-1 text-white hover:text-orange-500">
                <span>더보기</span>
                <FaChevronRight className="text-sm" />
              </button>
            </Link>
          </div>
        </div>
        <EventGrid
          limit={4}
        />
      </div>

      {/* ─ 출시 예정 ─ */}
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold">⏱️ 출시 예정</h2>
          <div className="flex gap-4 pr-6">
            <Link
              to="/games"
              state={{ showOnlyComingSoon: true }}
            >
              <button className="flex items-center space-x-1 text-white hover:text-orange-500">
                <span>더보기</span>
                <FaChevronRight className="text-sm" />
              </button>
            </Link>
          </div>
        </div>
        <GameGrid
          collectionName="games"
          filterSoon={true}
          limit={4}
        />
      </div>
    </div>
  );
}
